export const FETCH_EXCHANGE_RATES_STARTED = 'FETCH_EXCHANGE_RATES_STARTED';
export const FETCH_EXCHANGE_RATES_SUCCEEDED = 'FETCH_EXCHANGE_RATES_SUCCEEDED';
export const FETCH_EXCHANGE_RATES_FAILED = 'FETCH_EXCHANGE_RATES_FAILED';
